var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.977,
    height: 66.925,
    viewBox: "0 0 48.977 66.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2",
    "data-name": "Clip 2",
    d: "M0,0H48.977V56.823H0Z",
    transform: "translate(0 0.177)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_5",
    "data-name": "Clip 5",
    d: "M0,0H28.908V14.711H0Z",
    transform: "translate(0.049 0.075)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 -0.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-2",
    "data-name": "Clip 2",
    d: "M0,0H48.977V56.823H0Z",
    transform: "translate(0 0.177)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M48.977,29.888a4.547,4.547,0,0,0-4.575-4.52h0a4.571,4.571,0,0,0-4.337,3.084v-1.1a4.885,4.885,0,0,0-4.575-4.52,4.57,4.57,0,0,0-4.335,3.084v-1.1a4.884,4.884,0,0,0-4.575-4.52,4.57,4.57,0,0,0-4.337,3.09V4.52A4.885,4.885,0,0,0,17.668,0a4.548,4.548,0,0,0-4.575,4.52v29.7L8.539,26.423a4.949,4.949,0,0,0-6.25-1.655A4.491,4.491,0,0,0,.614,30.943L12.957,52.066a3.525,3.525,0,0,0,.542.693,8.436,8.436,0,0,0,6.7,4.064H39.387c3.615,0,7.231-3.295,8.068-7.358l.641-3.711a4.2,4.2,0,0,0,.053-.494h0Z",
    transform: "translate(0 0.177)",
    fill: "#444"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_5-2",
    "data-name": "Clip 5",
    d: "M0,0H28.908V14.711H0Z",
    transform: "translate(0.049 0.075)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-2",
    "data-name": "Group 6",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M28.908,14.711H24.154a9.8,9.8,0,0,0-9.7-9.873,9.8,9.8,0,0,0-9.7,9.873H0A14.6,14.6,0,0,1,14.454,0,14.6,14.6,0,0,1,28.908,14.711",
    transform: "translate(0.049 0.075)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step-1.c1520549ea266ae27c944ad079bfca38.svg";
export { ForwardRef as ReactComponent };